var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#3d60d3",
    viewBox: "0 0 9.414 5.414"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y2: 4,
    transform: "translate(4)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,4,0,0",
    transform: "translate(4 4) rotate(180)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
};
export default SvgAngleDown;